import { ContentRecommendation, EmptyLoadingElement } from '@/components/content/ContentRecommendation';
import { Skeleton } from '@mui/material';

const generateEmsName = (searchTerm: string) => `DPV2_CatalogEntrySearch_${searchTerm.trim().toUpperCase()}`;

export const CatalogEntrySearchSpot = ({ searchTerm }: { searchTerm: string }) => {
	const emsName = generateEmsName(searchTerm);

	return (
		<ContentRecommendation
			id={emsName}
			properties={{ emsName }}
			withoutFrame
			loadingElement={
				<Skeleton variant="rounded" sx={{ height: { xs: '220px', sm: '260px' }, width: '100%' }} />
			}
			emptyElement={<EmptyLoadingElement />}
		/>
	);
};
